import { render, staticRenderFns } from "./settingsAttributeIcon.vue?vue&type=template&id=02c953f8&scoped=true"
import script from "./settingsAttributeIcon.vue?vue&type=script&lang=js"
export * from "./settingsAttributeIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c953f8",
  null
  
)

export default component.exports